// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__2ifuu","container":"Home_container__3JNw6","button":"Home_button__9Y-fa","btnvolver":"Home_btnvolver__-P7cu","link":"Home_link__3vwIa"};